/**
 * Символ, по которому поднимаем список пользователей чата
 * */
export const RAISE_CHAT_MEMBERS_DROPDOWN_AT = '@';
